import { useEffect } from "react";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/solid";
import { Link, useLocation } from "react-router-dom";
import { useTrackContext } from "../../hooks/useTrackContext";
import mainTrackImageBanner from "../../assets/images/main_track_.jpg";
import miniTrackImageBanner from "../../assets/images/miniTrack_.jpeg";
import virtualRealityImageBanner from "../../assets/images/virtualReality.jpg";

interface INavProps {
  title: string;
  subtitle?: string;
  previous: {
    handleCallback?: () => void;
    active: boolean;
    to: string;
  };
  next: {
    handleCallback?: () => void;
    active: boolean;
    to: string;
  };
}

const Navigation = (props: INavProps) => {
  const { dispatch, productRenderedLocation, metaObjectTrackSelectionConfig } = useTrackContext();
  const { previous, next, title, subtitle = "" } = props;
  const location = useLocation();

  const isBattleKart = location.pathname.includes("battle-kart");

  const buttonStyles = {
    active: {
      background: isBattleKart ? "linear-gradient(#EA581A)" : "linear-gradient(172deg, #9D62FE 18.75%, #7886FF 100%)",
      cursor: "pointer",
      color: "white",
    },
    inactive: {
      background: "#393B41",
      cursor: "not-allowed",
      color: "#777777",
    },
  };

  useEffect(() => {
    if (location.pathname.includes("main-track")) {
      dispatch({
        type: "SET_SELECTED_TRACK",
        payload: {
          selectedTrackTitle: "MAIN_TRACK",
          trackBanner: mainTrackImageBanner,
        },
      });
    } else if (location.pathname.includes("mini-track")) {
      dispatch({
        type: "SET_SELECTED_TRACK",
        payload: {
          selectedTrackTitle: "MINI_TRACK",
          trackBanner: miniTrackImageBanner,
        },
      });
    } else if (location.pathname.includes("virtual-reality")) {
      dispatch({
        type: "SET_SELECTED_TRACK",
        payload: {
          selectedTrackTitle: "VIRTUAL_REALITY",
          trackBanner: virtualRealityImageBanner,
        },
      });
    } else if (location.pathname.includes("battle-kart")) {
      dispatch({
        type: "SET_SELECTED_TRACK",
        payload: {
          selectedTrackTitle: "BATTLE_KART_TRACK",
          trackBanner: mainTrackImageBanner,
        },
      });
    }
  }, [dispatch, location.pathname, next.to, previous.to]);

  const isTrackSelectionPage = location.pathname === "/";

  return (
    <div className={`${productRenderedLocation === "external" ? "tw-container tw-mx-auto tw-px-[15px] xl:tw-px-[0]" : "container mx-auto"}`}>
      <div className="tw-flex tw-gap-[20px] lg:tw-gap-0 lg:tw-justify-between tw-items-center tw-pt-0 lg:tw-pt-[63px] tw-pb-0 lg:tw-pb-[10px]">
        {!isTrackSelectionPage && previous.handleCallback && (
          <button
            style={previous.active ? buttonStyles.active : buttonStyles.inactive}
            className="tw-text-white tw-p-[8px] tw-rounded-[15px] hover:tw-cursor-pointer focus:tw-outline-none"
            disabled={!previous.active}
            onClick={previous.handleCallback}
          >
            <ChevronLeftIcon className="tw-w-[45px] tw-h-[45px]" />
          </button>
        )}

        {!isTrackSelectionPage && !previous.handleCallback && (
          <Link to={location.state !== null ? location.state?.previous : previous.to}>
            <button
              style={previous.active ? buttonStyles.active : buttonStyles.inactive}
              className="tw-text-white tw-p-[8px] tw-rounded-[15px] hover:tw-cursor-pointer focus:tw-outline-none"
              disabled={!previous.active}
            >
              <ChevronLeftIcon className="tw-w-[45px] tw-h-[45px]" />
            </button>
          </Link>
        )}

        <div className={`tw-text-center tw-text-white tw-hidden lg:tw-block ${isTrackSelectionPage ? "tw-w-full" : ""}`}>
          <span className={`tw-block tw-text-white tw-font-extrabold tw-text-[24px] lg:tw-text-[34px] ${isBattleKart ? "add-grobold-font" : ""}`}>{title}</span>
          {subtitle && (
            <span
              className={`tw-block ${
                subtitle.toLowerCase() === "virtual reality"
                  ? "tw-text-[#9D62FE]"
                  : subtitle.toLowerCase() === "arcade game card"
                  ? "tw-bg-clip-text tw-text-transparent tw-bg-gradient-to-r tw-from-[#05FFFA] tw-to-[#F908FF]"
                  : subtitle.toLocaleLowerCase() === "mini track"
                  ? "tw-text-[#19E6FE]"
                  : subtitle.toLowerCase() === "battle kart track"
                  ? "tw-text-[#EA581A]"
                  : "tw-text-[#F609FF]"
              } tw-text-[20px] tw-font-bold ${isBattleKart ? "add-grobold-font" : ""}`}
            >
              {subtitle.toLowerCase() === "main track" &&
              metaObjectTrackSelectionConfig &&
              metaObjectTrackSelectionConfig.mainTrack &&
              metaObjectTrackSelectionConfig.mainTrack.title
                ? metaObjectTrackSelectionConfig.mainTrack.title
                : subtitle}
            </span>
          )}
        </div>

        {!isTrackSelectionPage && next.handleCallback && (
          <button
            style={next.active && next.to !== "#" ? buttonStyles.active : buttonStyles.inactive}
            className="tw-text-white tw-p-[8px] tw-rounded-[15px] hover:tw-cursor-pointer focus:tw-outline-none"
            disabled={!next.active}
            onClick={next.handleCallback}
          >
            <ChevronRightIcon className="tw-w-[45px] tw-h-[45px] testmarge" />
          </button>
        )}

        {!isTrackSelectionPage && !next.handleCallback && (
          <Link to={next.active ? next.to : "#"}>
            <button
              style={next.active && next.to !== "#" ? buttonStyles.active : buttonStyles.inactive}
              className="tw-text-white tw-p-[8px] tw-rounded-[15px] hover:tw-cursor-pointer focus:tw-outline-none"
              disabled={!next.active}
            >
              <ChevronRightIcon className="tw-w-[45px] tw-h-[45px] testmarge" />
            </button>
          </Link>
        )}
      </div>
    </div>
  );
};

export default Navigation;
